module.exports = __webpack_public_path__ + "img/win-s2-8.39112cc3.png";